<div class="px-3 h-full mt-8 lg:mt-5">

  @if(!alboRole){
    <div class="flex align-items-center">
      @if(!nuovoIscritto && infoOriginali?.statoIscritto?.codiceCnop !== 'P'){
        @if(syncSpinner){
          <div class="pr-4 pt-1">
            <i class="pi pi-spin pi-cog" style="font-size: 2rem"></i>
          </div>
        }
        @else{
          <div>
            <p-button
              icon="pi pi-upload"
              (click)="startSynch(infoOriginali?.anagrafica!.id!)"
              class="mr-3"
              [disabled]="disableBottoneSync()"
              [pTooltip]="translate.instant('tooltip.aggiornaIscritto')"
              tooltipPosition="bottom"></p-button>
          </div>
        }
      }
      @if(isLoadingSpinner){
        <div class="pl-2 pr-4 pt-1">
          <i class="pi pi-spin pi-cog" style="font-size: 2rem"></i>
        </div>
      }
      @else{
        <div>
          <p-button
            icon="pi pi-save"
            [disabled]="disableBottoneSalva()"
            (click)="inviaDatiIscritto()"
            class="mr-3"
            [pTooltip]="translate.instant('tooltip.salva')"
            tooltipPosition="bottom"></p-button>
        </div>
      }
      @if(!nuovoIscritto && (iscrittoForm.get('albo.statoIscritto')?.value)?.id == 1){
        <div>
          <p-menu #menu [model]="vociStampa" [popup]="true" appendTo="body"></p-menu>
          <!-- label="Stampa" -->
          <button
            pButton
            type="button"
            (click)="menu.toggle($event)"
            icon="pi pi-print"
            [pTooltip]="translate.instant('tooltip.stampe')"
            tooltipPosition="bottom"></button>
        </div>
      }
      @if(iscrittoForm.get('albo.statoIscritto')?.value?.id == 6 && !nuovoProvvisorio){
        <div>
          <p-button
            icon="pi pi-trash"
            (click)="confirmEliminazione($event)"
            class="mr-3"
            [pTooltip]="translate.instant('tooltip.eliminaProvvisorio')"
            tooltipPosition="bottom" />
        </div>
        <p-confirmPopup />
      }
    </div>
  }

  <form [formGroup]="iscrittoForm">
    <p-tabView (onChange)="onChange($event)" #tv>

      <!-- anagrafica -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <span [ngClass]="{'custom-tab-panel': iscrittoForm.get('anagrafica')?.invalid}">
            {{ translate.instant('gestioneAlbo.dettaglioIscritto.tab.anagrafica') }}
          </span>
        </ng-template>
        <div class="flex flex-column backPanel border-round-3xl px-5 pt-5 pb-2" formGroupName="anagrafica">

          <!-- prima riga -->
          <div class="flex flex-wrap">

            <p-fieldset [legend]="translate.instant('gestioneAlbo.dettaglioIscritto.fieldset.informazioni')" class="mb-6 w-full">
              <div class="flex flex-wrap pt-3">

                <div class="mb-6">
                  <span class="p-float-label px-3">
                    <input
                     class="px-0"
                     pInputText
                     id="codiceFiscale"
                     maxlength="16"
                     pKeyFilter="alphanum"
                     formControlName="codiceFiscale"
                     [ngClass]="{'label-error': this.iscrittoForm.get('anagrafica.codiceFiscale')?.invalid}" />
                    <label
                      class="pl-1"
                      for="codiceFiscale"
                      [ngClass]="{'custom-tab-panel': iscrittoForm.get('anagrafica.codiceFiscale')?.invalid}">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.informazioni.codiceFiscale') }}
                    </label>
                  </span>
                  @if (this.iscrittoForm.get('anagrafica.codiceFiscale')?.errors?.['pattern']) {
                    <span class="not-valid-char ml-3">{{ notValidChar }}</span>
                  }
                </div>

                <div class="dataPickerCustom">
                  <span class="p-float-label px-3 mb-6">
                    <p-calendar formControlName="dataNascita" dateFormat="dd/mm/yy" inputId="dataNascita" [iconDisplay]="'input'" [showIcon]="true"></p-calendar>
                    <label class="pl-1" for="dataNascita" [ngClass]="{'custom-tab-panel': iscrittoForm.get('anagrafica.dataNascita')?.invalid}">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.informazioni.dataNascita') }}
                    </label>
                  </span>
                </div>

              </div>

              <div class="flex flex-wrap pt-3">

                <div class="mb-6">
                  <span class="p-float-label px-3">
                    <input
                      class="px-0"
                      pInputText
                      id="nome"
                      formControlName="nome"
                      [ngClass]="{'label-error': this.iscrittoForm.get('anagrafica.nome')?.invalid}"/>
                    <label
                      class="pl-1"
                      for="nome"
                      [ngClass]="{'label-error': this.iscrittoForm.get('anagrafica.nome')?.invalid}">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.informazioni.nome') }}
                    </label>
                  </span>
                  @if (this.iscrittoForm.get('anagrafica.nome')?.errors?.['pattern']) {
                    <span class="not-valid-char ml-3">{{ notValidChar }}</span>
                  }
                </div>

                <div class="mb-6">
                  <span class="p-float-label px-3">
                    <input
                      class="px-0"
                      pInputText
                      id="cognome"
                      formControlName="cognome"
                      [ngClass]="{'custom-tab-panel': iscrittoForm.get('anagrafica.cognome')?.invalid}"/>
                    <label
                      class="pl-1"
                      for="cognome"
                      [ngClass]="{'custom-tab-panel': iscrittoForm.get('anagrafica.cognome')?.invalid}">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.informazioni.cognome') }}
                    </label>
                  </span>
                  @if (this.iscrittoForm.get('anagrafica.cognome')?.errors?.['pattern']) {
                    <span class="not-valid-char ml-3">{{ notValidChar }}</span>
                  }
                </div>

                <div>
                  <span class="p-float-label px-3 mb-6">
                    <p-dropdown
                      [options]="sessi"
                      formControlName="sesso"
                      placeholder="scegli un sesso"
                      optionLabel="nome"
                      optionValue="valore"
                      inputId="sesso" />
                    <label class="pl-1" for="sesso" [ngClass]="{'custom-tab-panel': iscrittoForm.get('anagrafica.sesso')?.invalid}">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.informazioni.sesso') }}
                    </label>
                  </span>
                </div>

              </div>

              <div class="flex flex-wrap pt-3">

                <div class="mb-6">
                  <span class="p-float-label px-3">
                    <input
                      class="px-0"
                      pInputText
                      id="alias"
                      formControlName="alias"
                      [ngClass]="{'label-error': this.iscrittoForm.get('anagrafica.alias')?.errors?.['pattern']}" />
                    <label
                      class="pl-1"
                      for="alias"
                      [ngClass]="{'label-error': this.iscrittoForm.get('anagrafica.alias')?.errors?.['pattern']}">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.informazioni.alias') }}
                    </label>
                  </span>
                  @if (this.iscrittoForm.get('anagrafica.alias')?.errors?.['pattern']) {
                    <span class="not-valid-char ml-3">{{ notValidChar }}</span>
                  }
                </div>

                <div>
                  <span class="p-float-label px-3 mb-6">
                    <p-dropdown
                      [options]="sessi"
                      formControlName="sessoAlias"
                      optionLabel="nome"
                      optionValue="valore"
                      inputId="sesso"
                      class="spazioClear"
                      showClear="true" />
                    <label class="pl-1" for="sessoAlias">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.informazioni.sessoAlias') }}
                    </label>
                  </span>
                </div>

              </div>

              <div class="flex flex-wrap pt-3">

                <div class="mb-6">
                  <span class="p-float-label px-3">
                    <input
                      class="px-0"
                      pInputText
                      id="luogoNascita"
                      formControlName="luogoNascita"
                      [ngClass]="{'custom-tab-panel': iscrittoForm.get('anagrafica.luogoNascita')?.invalid}"/>
                    <label
                      class="pl-1"
                      for="luogoNascita"
                      [ngClass]="{'custom-tab-panel': iscrittoForm.get('anagrafica.luogoNascita')?.invalid}">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.informazioni.luogoNascita') }}
                    </label>
                  </span>
                  @if (this.iscrittoForm.get('anagrafica.luogoNascita')?.errors?.['pattern']) {
                    <span class="not-valid-char ml-3">{{ notValidChar }}</span>
                  }
                </div>

                <div>
                  <span class="p-float-label px-3 mb-6">
                    <p-autoComplete appendTo="body" optionDisabled="disabled" formControlName="provinciaNascita" [suggestions]="filteredProvince" (completeMethod)="filterAutoComplete($event, 'province')" field="nome" [minLength]="2" [showClear]="true">

                      <ng-template let-provincia pTemplate="item">
                        <div class="flex align-items-center gap-2">
                          <div>{{ provincia.codice }} - {{ provincia.nome }}</div>
                        </div>
                      </ng-template>

                    </p-autoComplete>
                    <label class="pl-1" for="provinciaNascita" [ngClass]="{'custom-tab-panel': iscrittoForm.get('anagrafica.provinciaNascita')?.invalid}">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.informazioni.provinciaNascita') }}
                    </label>
                  </span>
                </div>

                <div>
                  <span class="p-float-label px-3 mb-6">
                    <p-autoComplete appendTo="body" formControlName="cittadinanza" [suggestions]="filteredNazione" (completeMethod)="filterAutoComplete($event, 'cittadinanza')" field="nazionalita" [minLength]="3" [showClear]="true">

                      <ng-template let-nazione pTemplate="item">
                        <div class="flex align-items-center gap-2">
                          <div>{{ nazione.nazionalita }}</div>
                        </div>
                      </ng-template>

                    </p-autoComplete>
                    <label class="pl-1" for="cittadinanza" [ngClass]="{'custom-tab-panel': iscrittoForm.get('anagrafica.cittadinanza')?.invalid}">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.informazioni.cittadinanza') }}
                    </label>
                  </span>
                </div>

              </div>


              <div class="flex flex-wrap mb-3 gap-4">

                <div class="flex align-items-center pl-3 mb-3">
                  <p-checkbox class="mr-1" formControlName="permessoSoggiorno" [binary]="true" inputId="permessoSoggiorno"></p-checkbox>
                  <label class="checkboxLabelCustom" for="permessoSoggiorno" [ngClass]="{'label-error': flagSoggiorno}">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.informazioni.permessoSoggiorno') }}
                  </label>
                </div>

                <div class="dataPickerCustom">
                  <span class="p-float-label px-3 mb-3">
                    <p-calendar formControlName="permessoSoggiornoScadenza" dateFormat="dd/mm/yy" inputId="permessoSoggiornoScadenza" [iconDisplay]="'input'" [showIcon]="true"></p-calendar>
                    <label class="pl-1" for="permessoSoggiornoScadenza" [ngClass]="{'label-error': flagScadenzaSoggiorno}">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.informazioni.permessoSoggiornoScadenza') }}
                    </label>
                  </span>
                </div>

                <div class="flex align-items-center pl-3">
                  <p-checkbox class="mr-1" formControlName="permessoSoggiornoIllimitato" [binary]="true" inputId="permessoSoggiornoIllimitato"></p-checkbox>
                  <label class="checkboxLabelCustom" for="permessoSoggiornoIllimitato" [ngClass]="{'label-error': flagSoggiornoIllimitato}">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.informazioni.permessoSoggiornoIllimitato') }}
                  </label>
                </div>

              </div>

            </p-fieldset>

          </div>

          <!-- prima riga -->
          <p-fieldset [legend]="translate.instant('gestioneAlbo.dettaglioIscritto.fieldset.residenza')" class="mb-6">
            <div class="flex flex-wrap pt-3">

              <div class="mb-6">
                <span class="p-float-label px-3">
                  <input
                    class="px-0"
                    pInputText
                    id="residenzaIndirizzo"
                    formControlName="residenzaIndirizzo"
                    [ngClass]="{'label-error': this.iscrittoForm.get('anagrafica.residenzaIndirizzo')?.invalid}" />
                  <label
                    class="pl-1"
                    for="residenzaIndirizzo"
                    [ngClass]="{'label-error': this.iscrittoForm.get('anagrafica.residenzaIndirizzo')?.invalid}">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.residenza.indirizzo') }}
                  </label>
                </span>
                @if (this.iscrittoForm.get('anagrafica.residenzaIndirizzo')?.errors?.['pattern']) {
                  <span class="not-valid-char ml-3">{{ notValidChar }}</span>
                }
              </div>

              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="residenzaCap" maxlength="10" formControlName="residenzaCap"/>
                  <label class="pl-1" for="residenzaCap">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.residenza.cap') }}
                  </label>
                </span>
              </div>

              <div>
                <span class="p-float-label px-3 mb-6">
                  <p-autoComplete appendTo="body" optionDisabled="disabled" formControlName="residenzaComune" [suggestions]="filteredComuni" (completeMethod)="filterAutoComplete($event, 'comuni')" field="nome" [minLength]="3" [showClear]="true">

                    <ng-template let-comune pTemplate="item">
                      <div class="flex align-items-center gap-2">
                          <div>{{ comune.nome }}</div>
                      </div>
                    </ng-template>

                  </p-autoComplete>
                  <label class="pl-1" for="residenzaComune">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.residenza.comune') }}
                  </label>
                </span>
              </div>



              <div>
                <span class="p-float-label px-3 mb-6">
                  <p-autoComplete appendTo="body" optionDisabled="disabled" formControlName="residenzaProvincia" [suggestions]="filteredProvince" (completeMethod)="filterAutoComplete($event, 'province')" field="nome" [minLength]="2" [showClear]="true">

                    <ng-template let-provincia pTemplate="item">
                      <div class="flex align-items-center gap-2">
                        <div>{{ provincia.codice }} - {{ provincia.nome }}</div>
                      </div>
                    </ng-template>

                  </p-autoComplete>
                  <label class="pl-1" for="residenzaProvincia">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.residenza.provincia') }}
                  </label>
                </span>
              </div>

              <div>
                <span class="p-float-label px-3 mb-6">
                  <p-autoComplete appendTo="body" formControlName="residenzaStato" [suggestions]="filteredNazione" (completeMethod)="filterAutoComplete($event, 'nazioni')" field="nome" [minLength]="3" [showClear]="true">

                    <ng-template let-nazione pTemplate="item">
                      <div class="flex align-items-center gap-2">
                        <div>{{ nazione.nome }}</div>
                      </div>
                    </ng-template>

                  </p-autoComplete>
                  <label class="pl-1" for="residenzaStato">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.residenza.stato') }}
                  </label>
                </span>
              </div>

              <div class="mb-6">
                <span class="p-float-label px-3">
                  <input
                    class="px-0"
                    pInputText
                    id="residenzaLuogo"
                    formControlName="residenzaLuogo"
                    [ngClass]="{'label-error': this.iscrittoForm.get('anagrafica.residenzaLuogo')?.errors?.['pattern']}" />
                  <label
                    class="pl-1"
                    for="residenzaLuogo"
                    [ngClass]="{'label-error': this.iscrittoForm.get('anagrafica.residenzaLuogo')?.errors?.['pattern']}">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.residenza.luogo') }}
                  </label>
                </span>
                @if (this.iscrittoForm.get('anagrafica.residenzaLuogo')?.errors?.['pattern']) {
                  <span class="not-valid-char ml-3">{{ notValidChar }}</span>
                }
              </div>

            </div>
          </p-fieldset>

          <!-- seconda riga -->
          <p-fieldset [legend]="translate.instant('gestioneAlbo.dettaglioIscritto.fieldset.domicilio')" class="mb-6">
            <div class="flex flex-wrap pt-3">

              <div class="mb-6">
                <span class="p-float-label px-3">
                  <input
                    class="px-0"
                    pInputText
                    id="domicilioIndirizzo"
                    formControlName="domicilioIndirizzo"
                    [ngClass]="{'label-error': this.iscrittoForm.get('anagrafica.domicilioIndirizzo')?.errors?.['pattern']}" />
                  <label
                    class="pl-1"
                    for="domicilioIndirizzo"
                    [ngClass]="{'label-error': this.iscrittoForm.get('anagrafica.domicilioIndirizzo')?.errors?.['pattern']}">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.domicilio.indirizzo') }}
                  </label>
                </span>
                @if (this.iscrittoForm.get('anagrafica.domicilioIndirizzo')?.errors?.['pattern']) {
                  <span class="not-valid-char ml-3">{{ notValidChar }}</span>
                }
              </div>

              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="domicilioCap" maxlength="10" formControlName="domicilioCap"/>
                  <label class="pl-1" for="domicilioCap">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.domicilio.cap') }}
                  </label>
                </span>
              </div>

              <div>
                <span class="p-float-label px-3 mb-6">
                  <p-autoComplete appendTo="body" optionDisabled="disabled" formControlName="domicilioComune" [suggestions]="filteredComuni" (completeMethod)="filterAutoComplete($event, 'comuni')" field="nome" [minLength]="3" [showClear]="true">

                    <ng-template let-comune pTemplate="item">
                      <div class="flex align-items-center gap-2">
                          <div>{{ comune.nome }}</div>
                      </div>
                    </ng-template>

                  </p-autoComplete>
                  <label class="pl-1" for="domicilioComune">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.domicilio.comune') }}
                  </label>
                </span>
              </div>

              <div>
                <span class="p-float-label px-3 mb-6">
                  <p-autoComplete appendTo="body" optionDisabled="disabled" formControlName="domicilioProvincia" [suggestions]="filteredProvince" (completeMethod)="filterAutoComplete($event, 'province')" field="nome" [minLength]="2" [showClear]="true">

                    <ng-template let-provincia pTemplate="item">
                      <div class="flex align-items-center gap-2">
                        <div>{{ provincia.codice }} - {{ capitalizeFirstLetters(provincia.nome) }}</div>
                      </div>
                    </ng-template>

                  </p-autoComplete>
                  <label class="pl-1" for="domicilioProvincia">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.domicilio.provincia') }}
                  </label>
                </span>
              </div>

              <div class="mb-6">
                <span class="p-float-label px-3">
                  <input
                    class="px-0"
                    pInputText
                    id="domicilioLuogo"
                    formControlName="domicilioLuogo"
                    [ngClass]="{'label-error': this.iscrittoForm.get('anagrafica.domicilioLuogo')?.errors?.['pattern']}" />
                  <label
                    class="pl-1"
                    for="domicilioLuogo"
                    [ngClass]="{'label-error': this.iscrittoForm.get('anagrafica.domicilioLuogo')?.errors?.['pattern']}">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.domicilio.luogo') }}
                  </label>
                </span>
                @if (this.iscrittoForm.get('anagrafica.domicilioLuogo')?.errors?.['pattern']) {
                  <span class="not-valid-char ml-3">{{ notValidChar }}</span>
                }
              </div>

            </div>

          </p-fieldset>

          <!-- terza riga -->
          <p-fieldset [legend]="translate.instant('gestioneAlbo.dettaglioIscritto.fieldset.contatti')" class="mb-6 contattiField">
            <div class="flex flex-wrap gap-8 py-5">

              <div class="md:mr-5">
                <span class="p-float-label px-3 mb-3">
                  <input class="px-0 inputCustom" pInputText id="email" formControlName="email"/>
                  <label class="pl-1" for="email" [ngClass]="{'custom-tab-panel': iscrittoForm.get('anagrafica.email')?.invalid}">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.contatti.email') }}
                  </label>
                </span>
              </div>

              <div class="md:mr-5">
                <span class="p-float-label px-3 mb-3">
                  <input class="px-0 inputCustom" pInputText id="pec" formControlName="pec"/>
                  <label class="pl-1" for="pec">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.contatti.pec') }}
                  </label>
                </span>
              </div>

              <div class="flex">

                <div>
                  <span class="p-float-label px-3 mb-3 prefissi">
                    <p-autoComplete
                      (ngModelChange)="onTelefonoChange($event, 'prefisso')"
                      appendTo="body"
                      formControlName="prefissoTelefonoPrincipale"
                      [suggestions]="filteredPrefisso"
                      (completeMethod)="filterAutoComplete($event, 'prefisso')"
                      field="codice"
                      placeholder="Es: 'italia'"
                      [minLength]="2"
                      [showClear]="true">

                      <ng-template let-prefisso pTemplate="item">
                        <div class="flex align-items-center gap-2">
                            <div>{{ prefisso.bandiera }} {{ prefisso.nazione }} ({{ prefisso.codice }})</div>
                        </div>
                      </ng-template>

                    </p-autoComplete>
                    <label
                      [ngClass]="{'custom-tab-panel': iscrittoForm.get('anagrafica.prefissoTelefonoPrincipale')?.invalid}"
                      class="pl-1"
                      for="prefissoTelefonoPrincipale">
                        {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.contatti.prefisso') }}
                    </label>
                  </span>
                </div>

                <div>
                  <span class="p-float-label px-3 mb-3">
                    <input
                      (ngModelChange)="onTelefonoChange($event, 'telefono')"
                      class="px-0 inputCustom"
                      pInputText id="telefonoPrincipale"
                      pKeyFilter="int"
                      formControlName="telefonoPrincipale"/>
                    <label
                      [ngClass]="{'custom-tab-panel': iscrittoForm.get('anagrafica.telefonoPrincipale')?.invalid}"
                      class="pl-1"
                      for="telefonoPrincipale">
                        {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.contatti.numeroPrincipale') }}
                      </label>
                  </span>
                </div>

              </div>

            </div>

            @if (!nuovoIscritto) {

              <div class="flex flex-column mb-5">

                @if (listaNumeriSecondari.length > 0) {

                  <p-table
                    [value]="listaNumeriSecondari"
                    class="mb-3"
                    [tableStyle]="{ 'max-width': '40rem' }"
                  >
                    <ng-template pTemplate="header">
                        <tr>
                          <th width="25%">{{ translate.instant('gestioneAlbo.dettaglioIscritto.form.contatti.numeroSecondario') }}</th>
                          <th width="15%">{{ translate.instant('gestioneAlbo.dettaglioIscritto.form.contatti.tipo') }}</th>
                          <th width="30%">{{ translate.instant('gestioneAlbo.dettaglioIscritto.form.contatti.descrizione') }}</th>
                          <th width="5%">
                            <p-button class="buttonTelefoni" icon="pi pi-plus" [rounded]="true" [text]="true" size="small" (click)="aggiungiNumero()"></p-button>
                          </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-telefono>
                        <tr>
                            <td>({{ telefono.prefisso ? telefono.prefisso.codice : '-' }}) {{ telefono.numero }}</td>
                            <td>{{ telefono.tipo }}</td>
                            <td>{{ telefono.descrizione }}</td>
                            <td>
                              <p-button class="buttonTelefoni" icon="pi pi-minus" severity="danger" [rounded]="true" [text]="true" size="small" (click)="eliminaNumero(telefono)"></p-button>
                            </td>
                        </tr>
                    </ng-template>
                  </p-table>
                }@else{
                  <div class="flex ml-3">
                    <p class="font-bold">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.contatti.aggiungiNumero') }}
                    </p>
                    <p-button class="buttonTelefoni" icon="pi pi-plus" [rounded]="true" [text]="true" size="small" (click)="aggiungiNumero()"></p-button>
                  </div>
                }

              </div>

            }


          </p-fieldset>

          @if (!nuovoIscritto) {
            <div class="flex flex-column align-items-center px-3 mb-6">

              <p-image
                [src]="immagineIscritto"
                alt="Image"
                width="180"
                height="180"
                [imageStyle]="{'object-fit': 'cover'}"
                class="immagineIscritto"
                [preview]="true" />
              <p-button
                (click)="cambiaFoto()"
                severity="primary"
                [label]="translate.instant('gestioneAlbo.dettaglioIscritto.fototessera.bottoneCambia')"
                class="bottoneFoto" />

              <p-dialog
                [header]="translate.instant('gestioneAlbo.dettaglioIscritto.fototessera.titolo')"
                [modal]="true"
                [(visible)]="cambioFotoDialog">
                <div>
                  <p-fileUpload
                    name="file"
                    method="post"
                    accept="image/jpeg"
                    maxFileSize="1000000"
                    customUpload="true"
                    (uploadHandler)="uploadImageFile()"
                    (onSelect)="onBasicSelect($event)"
                    [chooseLabel]="translate.instant('gestioneAlbo.dettaglioIscritto.fototessera.scegli')"
                    [uploadLabel]="translate.instant('gestioneAlbo.dettaglioIscritto.fototessera.invia')"
                    showCancelButton="false" />
                </div>
              </p-dialog>

            </div>
          }

        </div>
      </p-tabPanel>

      <!-- titoli -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <span [ngClass]="{'custom-tab-panel': iscrittoForm.get('titoli')?.invalid}">
            {{ translate.instant('gestioneAlbo.dettaglioIscritto.tab.titoli') }}
          </span>
        </ng-template>
        <div class="flex flex-column backPanel border-round-3xl px-5 pt-5 pb-2" formGroupName="titoli">

          <!-- LAUREA FIELDSET -->
          <p-fieldset [legend]="translate.instant('gestioneAlbo.dettaglioIscritto.fieldset.titoli')" class="mb-6">

            <!-- prima riga -->
            <div  class="p-float-label px-3 mb-6 pt-3">
              <p-dropdown formControlName="titolo" [options]="titoloOptions" optionLabel="nome" [showClear]="true" [style]="{'width': '100%'}"></p-dropdown>
              <label class="pl-1" for="titolo" [ngClass]="{'custom-tab-panel': iscrittoForm.get('titoli.titolo')?.invalid}">
                {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.titoli.titolo') }}
              </label>
            </div>

            <!-- seconda riga -->
            <div class="flex flex-wrap md:flex-nowrap">

              <div class="w-full">
                <span class="p-float-label px-3 mb-6">
                  <p-autoComplete [dropdown]="true" dropdownMode="current" appendTo="body" formControlName="laureaUniversita" [suggestions]="filteredUniversita" (completeMethod)="filterAutoComplete($event, 'universita')" field="nome" [minLength]="3" [showClear]="true" [style]="{'width': '100%'}">

                    <ng-template let-uni pTemplate="item">
                      <div class="flex align-items-center gap-2">
                        <div>{{ uni.nome }}</div>
                      </div>
                    </ng-template>

                  </p-autoComplete>
                  <label class="pl-1" for="laureaUniversita" [ngClass]="{'custom-tab-panel': iscrittoForm.get('titoli.laureaUniversita')?.invalid}">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.titoli.universita') }}
                  </label>
                </span>
              </div>

              <div class="dataPickerCustom p-float-label px-3 mb-6">
                <p-calendar
                  formControlName="laureaData"
                  inputId="laureaData"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  dateFormat="dd/mm/yy" />
                <label class="pl-1" for="laureaData">
                  {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.titoli.dataLaurea') }}
                </label>
              </div>

            </div>

            <div class="flex flex-wrap pl-3 mb-6">
              <div class="pr-3">
                <p-checkbox class="mr-1" formControlName="laureaAbilitante" [binary]="true" inputId="laureaAbilitante"></p-checkbox>
                <label class="checkboxLabelCustom" for="laureaAbilitante">
                  {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.titoli.laureaAbilitante') }}
                </label>
              </div>
            </div>

          </p-fieldset>

          <!-- ABILITAZIONI FIELDSET -->
          <p-fieldset [legend]="translate.instant('gestioneAlbo.dettaglioIscritto.fieldset.abilitazioni')" class="mb-6">

            <!-- terza riga -->
            <div class="p-float-label px-3 mb-6 pt-3">
              <p-dropdown formControlName="abilitazione" [options]="abilitazioneOptions" optionLabel="nome" [showClear]="true" [style]="{'width': '100%'}"></p-dropdown>
              <label class="pl-1" for="abilitazione">
                {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.abilitazioni.abilitazione') }}
              </label>
            </div>

            <!-- quarta riga -->
            <div class="uniCustom flex flex-wrap md:flex-nowrap pt-3">

              <div class="uniCustom w-full">
                <span class="p-float-label px-3 mb-6">
                  <p-autoComplete [dropdown]="true" dropdownMode="current" appendTo="body" formControlName="abilitazioneUniversita" [suggestions]="filteredUniversita" (completeMethod)="filterAutoComplete($event, 'universita')" field="nome" [minLength]="3" [showClear]="true"  [style]="{'width': '100%'}">

                    <ng-template let-uni pTemplate="item">
                      <div class="flex align-items-center gap-2">
                        <div>{{ uni.nome }}</div>
                      </div>
                    </ng-template>

                  </p-autoComplete>
                  <label class="pl-1" for="abilitazioneUniversita" [ngClass]="{'custom-tab-panel': iscrittoForm.get('titoli.abilitazioneUniversita')?.invalid}">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.abilitazioni.universita') }}
                  </label>
                </span>
              </div>

              <div class="mb-6">
                <span class="p-float-label px-3">
                  <input
                    class="px-0"
                    pInputText
                    id="abilitazioneData"
                    formControlName="abilitazioneData"
                    [ngClass]="{'label-error': this.iscrittoForm.get('titoli.abilitazioneData')?.errors?.['pattern']}" />
                  <label
                    class="pl-1"
                    for="abilitazioneData"
                    [ngClass]="{'label-error': this.iscrittoForm.get('titoli.abilitazioneData')?.errors?.['pattern']}">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.abilitazioni.dataAbilitazione') }}
                  </label>
                </span>
                @if (this.iscrittoForm.get('titoli.abilitazioneData')?.errors?.['pattern']) {
                  <span class="not-valid-char">{{ notValidChar }}</span>
                }
              </div>

            </div>

            <div class="pl-3 mb-6">
              <p-checkbox class="mr-1" formControlName="abilitazioneRiserva" [binary]="true" inputId="abilitazioneRiserva"></p-checkbox>
              <label class="checkboxLabelCustom" for="abilitazioneRiserva">
                {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.abilitazioni.abilitazioneRiserva') }}
              </label>
            </div>

            <div class="flex flex-wrap flex-column">

              <div class="flex flex-wrap mb-6">

                <div class="flex align-items-center pl-3 mb-6 xl:mb-3">
                  <p-checkbox class="mr-1" formControlName="psicoterapeuta" [binary]="true" inputId="psicoterapeuta"></p-checkbox>
                  <label class="checkboxLabelCustom" for="psicoterapeuta">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.abilitazioni.psicoterapeutaFlag') }}
                  </label>
                </div>

                <div class="p-float-label px-3 mb-6 xl:mb-3">
                  <p-dropdown class="spazioClear" [options]="psicoterapeutaOptions" formControlName="psicoterapeutaOption" optionLabel="nome" inputId="psicoterapeuta" showClear="true"></p-dropdown>
                  <label class="pl-1" for="psicoterapeutaOption">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.abilitazioni.psicoterapeutaArticolo') }}
                  </label>
                </div>

                <div class="psicoData">
                  <span class="p-float-label px-3 pr-6">
                    <p-calendar class="spazioClear" formControlName="psicoterapeutaData" dateFormat="dd/mm/yy" inputId="psicoterapeutaData" [iconDisplay]="'input'" [showIcon]="true"></p-calendar>
                    <label class="pl-1" for="psicoterapeutaData">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.abilitazioni.psicoterapeutaData') }}
                    </label>
                  </span>
                </div>

              </div>

              <div class="flex flex-wrap mb-6">

                <div class="flex align-items-center pl-3 mb-6 xl:mb-3">
                  <p-checkbox class="mr-1" formControlName="neuropsicologo" [binary]="true" inputId="neuropsicologo"></p-checkbox>
                  <label class="checkboxLabelCustom" for="neuropsicologo">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.abilitazioni.neuropsicologoFlag') }}
                  </label>
                </div>

                <div class="mb-6 xl:mb-3">
                  <span class="p-float-label px-3">
                    <input
                      class="px-0"
                      pInputText
                      id="neuropsicologoProtocollo"
                      formControlName="neuropsicologoProtocollo"
                      [ngClass]="{'label-error': this.iscrittoForm.get('titoli.neuropsicologoProtocollo')?.errors?.['pattern']}" />
                    <label
                      class="pl-1"
                      for="neuropsicologoProtocollo"
                      [ngClass]="{'label-error': this.iscrittoForm.get('titoli.neuropsicologoProtocollo')?.errors?.['pattern']}">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.abilitazioni.neuropsicologoProtocollo') }}
                    </label>
                  </span>
                  @if (this.iscrittoForm.get('titoli.neuropsicologoProtocollo')?.errors?.['pattern']) {
                    <span class="not-valid-char ml-3">{{ notValidChar }}</span>
                  }
                </div>

                <div class="psicoData">
                  <span class="p-float-label px-3 pr-6">
                    <p-calendar class="spazioClear" formControlName="neuropsicologoProtocolloData" dateFormat="dd/mm/yy" inputId="neuropsicologoProtocolloData" [iconDisplay]="'input'" [showIcon]="true"></p-calendar>
                    <label class="pl-1" for="neuropsicologoProtocolloData">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.abilitazioni.neuropsicologoData') }}
                    </label>
                  </span>
                </div>

              </div>



            </div>

          </p-fieldset>

          <!-- quinta riga -->
          <p-fieldset [legend]="translate.instant('gestioneAlbo.dettaglioIscritto.fieldset.controlli')" class="customFieldset mb-4">
            <div class="flex flex-wrap pl-3 mb-5">
              <div class="pr-3">
                <p-checkbox class="mr-1" formControlName="controlloCasellario" [binary]="true" inputId="controlloCasellario"></p-checkbox>
                <label class="checkboxLabelCustom" for="controlloCasellario">
                  {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.controlli.casellario') }}
                </label>
              </div>

              <div class="px-3">
                <p-checkbox class="mr-1" formControlName="controlloLaurea" [binary]="true" inputId="controlloLaurea"></p-checkbox>
                <label class="checkboxLabelCustom" for="controlloLaurea">
                  {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.controlli.laurea') }}
                </label>
              </div>

              <div class="px-3">
                <p-checkbox class="mr-1" formControlName="controlloAbilitazione" [binary]="true" inputId="controlloAbilitazione"></p-checkbox>
                <label class="checkboxLabelCustom" for="controlloAbilitazione">
                  {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.controlli.abilitazione') }}
                </label>
              </div>
            </div>
          </p-fieldset>

        </div>
      </p-tabPanel>

      <!-- albo -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <span [ngClass]="{'custom-tab-panel': iscrittoForm.get('albo')?.invalid}">
            {{ translate.instant('gestioneAlbo.dettaglioIscritto.tab.albo') }}
          </span>
        </ng-template>
        <div class="flex flex-column backPanel border-round-3xl px-5 pt-5 pb-2" formGroupName="albo">

          <!-- ISCRIZIONE FIELDSET -->
          <p-fieldset [legend]="translate.instant('gestioneAlbo.dettaglioIscritto.fieldset.iscrizione')" class="mb-6">
            <div class="flex flex-wrap pt-3">
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText pKeyFilter="int" id="numeroIscrizione" formControlName="numeroIscrizione" readonly/>
                  <label
                    class="pl-1"
                    for="numeroIscrizione"
                    [ngClass]="{'custom-tab-panel': (nuovoIscritto || infoOriginali?.statoIscritto?.codiceCnop !== 'P') && iscrittoForm.get('albo.numeroIscrizione')?.invalid}">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.iscrizione.nIscrizione') }}
                  </label>
                </span>
              </div>
              <div class="dataPickerCustom">
                <span class="p-float-label px-3 mb-6">
                  <p-calendar
                    formControlName="dataIscrizione"
                    dateFormat="dd/mm/yy"
                    inputId="dataIscrizione"
                    [iconDisplay]="'input'"
                    [showIcon]="true" />
                  <label
                    class="pl-1"
                    for="dataIscrizione"
                    [ngClass]="{'custom-tab-panel': (nuovoIscritto || infoOriginali?.statoIscritto?.codiceCnop !== 'P') && iscrittoForm.get('albo.dataIscrizione')?.invalid}">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.iscrizione.dataIscrizione') }}
                  </label>
                </span>
              </div>
              <div>
                <span class="p-float-label px-3 mb-6">
                  <p-dropdown
                    [options]="sezioni"
                    formControlName="sezioneAlbo"
                    placeholder="scegli albo"
                    optionLabel="nome"
                    optionValue="valore"
                    inputId="sezioneAlbo" />
                  <label class="pl-1" for="sezioneAlbo" [ngClass]="{'custom-tab-panel': iscrittoForm.get('albo.sezioneAlbo')?.invalid}">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.iscrizione.sezione') }}
                  </label>
                </span>
              </div>
            </div>

            <div class="flex flex-wrap pt-3">
              <div>
                <span class="p-float-label px-3 mb-6">
                  <input class="px-0" pInputText id="domandaProtocollo" formControlName="domandaProtocollo"/>
                  <label class="pl-1" for="domandaProtocollo">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.iscrizione.protocolloDomanda') }}
                  </label>
                </span>
              </div>
              <div class="dataPickerCustom">
                <span class="p-float-label px-3 mb-6">
                  <p-calendar
                    formControlName="domandaData"
                    dateFormat="dd/mm/yy"
                    inputId="domandaData"
                    [iconDisplay]="'input'"
                    [showIcon]="true" />
                  <label class="pl-1" for="domandaData">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.iscrizione.dataDomanda') }}
                  </label>
                </span>
              </div>
              @if(altreIscrizioni){
                <div>
                  <span class="p-float-label px-3 mb-6">
                    <p-button
                      [label]="translate.instant('gestioneAlbo.dettaglioIscritto.form.iscrizione.altreIscrizioni')"
                      icon="pi pi-send"
                      iconPos="right"
                      (click)="goToCancellati()"
                      [rounded]="true"
                      [text]="true"
                      class="p-0 buttonStato" />
                  </span>
                </div>
              }
            </div>
          </p-fieldset>

          <!-- STATO ISCRITTO FIELDSET -->
          <p-fieldset [legend]="translate.instant('gestioneAlbo.dettaglioIscritto.fieldset.statoIscritto')" class="mb-6">
            <div class="flex flex-wrap pt-3 mb-1">
              <span class="p-float-label pl-3 mb-6">
                <input
                  class="px-0 font-bold" type="text"
                  pInputText
                  readonly
                  id="readStato"
                  [value]="iscrittoForm.get('albo.statoIscritto')?.value?.nome" />
                <label class="pl-1" for="readStato" [ngClass]="{'custom-tab-panel': iscrittoForm.get('albo.statoIscritto')?.invalid}">
                  {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.statoIscritto.stato') }}
                </label>
                @if((iscrittoForm.get('albo.statoIscritto')?.value?.nome !== 'CANCELLATO' &&
                  iscrittoForm.get('albo.statoIscritto')?.value?.nome !== 'RADIATO' &&
                  iscrittoForm.get('albo.statoIscritto')?.value?.nome !== 'PROVVISORIO')
                  && statoIscrittoReadonly){
                  <p-button
                    icon="pi pi-pencil"
                    (click)="modificaStato()"
                    [rounded]="true"
                    [text]="true"
                    class="p-0 buttonStato"
                    [disabled]="role_service.isConsultazioneRole()" />
                }
              </span>
            </div>
            <!-- seconda riga -->
            @if(infoOriginali?.statoIscritto?.codiceCnop === 'S'){
              <div class="flex flex-wrap mb-1">
                <div class="dataPickerCustom">
                  <span class="p-float-label px-3 mb-6">
                    <p-calendar
                      formControlName="sospensioneDal"
                      dateFormat="dd/mm/yy"
                      inputId="sospensioneDal"
                      [iconDisplay]="'input'"
                      [showIcon]="true" />
                    <label class="pl-1" for="sospensioneDal">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.statoIscritto.sospesoDal') }}
                    </label>
                  </span>
                </div>
                <!--<div class="dataPickerCustom">
                  <span class="p-float-label px-3 mb-6">
                    <p-calendar
                      formControlName="sospensioneAl"
                      dateFormat="dd/mm/yy"
                      inputId="sospensioneAl"
                      [iconDisplay]="'input'"
                      [showIcon]="true" />
                    <label class="pl-1" for="sospensioneAl">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.statoIscritto.sospesoAl') }}
                    </label>
                  </span>
                </div>-->
                <div>
                  <span class="p-float-label px-3 mb-6">
                    <p-dropdown
                      class="spazioClear"
                      formControlName="motivoSospensione"
                      [options]="articolo26Options"
                      optionLabel="descrizione"
                      [showClear]="true" />
                    <label class="pl-1" for="motivoSospensione">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.statoIscritto.motivoSospensione') }}
                    </label>
                  </span>
                </div>
                <div>
                  <span class="p-float-label px-3 mb-6">
                    <p-dropdown
                      class="spazioClear"
                      formControlName="procedimentoDisciplinare"
                      [options]="statoProcedimento"
                      optionLabel="nome"
                      [showClear]="true" />
                    <label class="pl-1" for="procedimentoDisciplinare">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.statoIscritto.procedimento') }}
                    </label>
                  </span>
                </div>
              </div>
            }
            @if(infoOriginali?.statoIscritto?.codiceCnop === 'C'){
              <div class="flex flex-wrap">
                <div class="dataPickerCustom p-float-label px-3 mb-6">
                  <p-calendar
                    formControlName="cancellatoData"
                    dateFormat="dd/mm/yy"
                    inputId="cancellatoData"
                    [iconDisplay]="'input'"
                    [showIcon]="true" />
                  <label class="pl-1" for="cancellatoData">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.statoIscritto.dataCancellazione') }}
                  </label>
                </div>
                <div class="p-float-label px-3 mb-6">
                  <p-dropdown
                    formControlName="motivoCancellazione"
                    [options]="motivoCancellazioneOptions"
                    optionLabel="nome"
                    optionDisabled="disabled"
                    class="spazioClear"
                    [showClear]="true" />
                  <label class="pl-1" for="motivoCancellazione">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.statoIscritto.motivoCancellazione') }}
                  </label>
                </div>
              </div>
            }
            @if(infoOriginali?.statoIscritto?.codiceCnop === 'R'){
              <div class="dataPickerCustom">
                <span class="p-float-label px-3 mb-6">
                  <p-calendar
                    formControlName="radiatoData"
                    dateFormat="dd/mm/yy"
                    inputId="radiatoData"
                    [iconDisplay]="'input'"
                    [showIcon]="true" />
                  <label class="pl-1" for="radiatoData">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.statoIscritto.dataRadiazione') }}
                  </label>
                </span>
              </div>
            }
            <div class="flex flex-wrap mb-1">
              <div>
                <span class="p-float-label px-3 mb-6">
                  <p-autoComplete
                    [dropdown]="true"
                    dropdownMode="current"
                    appendTo="body"
                    formControlName="trasferimentoDaOrdine"
                    [suggestions]="filteredOrdini"
                    (completeMethod)="filterAutoComplete($event, 'ordini')"
                    field="nome"
                    [showClear]="true">
                    <ng-template let-ordine pTemplate="item">
                      <div class="flex align-items-center gap-2">
                        <div>{{ ordine.nome }}</div>
                      </div>
                    </ng-template>
                  </p-autoComplete>
                  <label class="pl-1" for="trasferimentoDaOrdine">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.trasferimento.trasferimentoDa') }}
                  </label>
                </span>
              </div>
              <div>
                <span class="p-float-label px-3 mb-6">
                  <p-calendar
                    formControlName="trasferimentoEntrataData"
                    dateFormat="dd/mm/yy"
                    inputId="trasferimentoEntrataData"
                    [iconDisplay]="'input'"
                    [showIcon]="true" />
                  <label class="pl-1" for="trasferimentoEntrataData">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.trasferimento.trasferimentoEntrataData') }}
                  </label>
                </span>
              </div>
              @if(infoOriginali?.trasferimentoAOrdine != null){
                <div class="flex flex-wrap mb-1">
                  <div>
                    <span class="p-float-label px-3 mb-6">
                      <p-autoComplete
                        [dropdown]="true"
                        dropdownMode="current"
                        appendTo="body"
                        formControlName="trasferimentoAOrdine"
                        [suggestions]="filteredOrdini"
                        (completeMethod)="filterAutoComplete($event, 'ordini')"
                        field="nome"
                        [showClear]="true">
                        <ng-template let-ordine pTemplate="item">
                          <div class="flex align-items-center gap-2">
                            <div>{{ ordine.nome }}</div>
                          </div>
                        </ng-template>
                      </p-autoComplete>
                      <label class="pl-1" for="trasferimentoAOrdine">
                        {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.trasferimento.trasferimentoA') }}
                      </label>
                    </span>
                  </div>
                  <div>
                    <span class="p-float-label px-3 mb-6">
                      <p-calendar
                        formControlName="trasferimentoUscitaData"
                        dateFormat="dd/mm/yy"
                        inputId="trasferimentoUscitaData"
                        [iconDisplay]="'input'" [showIcon]="true"></p-calendar>
                      <label class="pl-1" for="trasferimentoUscitaData">
                        {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.trasferimento.trasferimentoUscitaData') }}
                      </label>
                    </span>
                  </div>
                </div>
              }
            </div>
          </p-fieldset>

          <!-- RUOLI PROFESSIONALI FIELDSET -->
          <p-fieldset [legend]="translate.instant('gestioneAlbo.dettaglioIscritto.fieldset.ruoli')" class="mb-6">
            <!-- prima riga -->
            <div class="flex flex-wrap pt-3 mb-1">
              <div>
                <span class="p-float-label px-3 mb-6">
                  <p-autoComplete
                    [dropdown]="true"
                    dropdownMode="current"
                    appendTo="body"
                    formControlName="ctu"
                    [suggestions]="filteredCTU"
                    (completeMethod)="filterAutoComplete($event, 'ctu')"
                    field="nome"
                    [minLength]="3"
                    [showClear]="true">
                    <ng-template let-ctu pTemplate="item">
                      <div class="flex align-items-center gap-2">
                        <div>{{ ctu.nome }}</div>
                      </div>
                    </ng-template>
                  </p-autoComplete>
                  <label class="pl-1" for="ctu" [ngClass]="{'custom-tab-panel': iscrittoForm.get('albo.ctu')?.invalid}">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.statoIscritto.ctu') }}
                  </label>
                </span>
              </div>
              <div>
                <span class="p-float-label px-3 mb-6">
                  <p-autoComplete
                    [dropdown]="true"
                    dropdownMode="current"
                    appendTo="body"
                    formControlName="perito"
                    [suggestions]="filteredCTU"
                    (completeMethod)="filterAutoComplete($event, 'ctu')"
                    field="nome"
                    [minLength]="3"
                    [showClear]="true">
                    <ng-template let-perito pTemplate="item">
                      <div class="flex align-items-center gap-2">
                        <div>{{ perito.nome }}</div>
                      </div>
                    </ng-template>
                  </p-autoComplete>
                  <label class="pl-1" for="perito" [ngClass]="{'custom-tab-panel': iscrittoForm.get('albo.perito')?.invalid}">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.statoIscritto.perito') }}
                  </label>
                </span>
              </div>
            </div>
            <!-- seconda riga -->
            <div class="flex flex-wrap mb-6">
              <div class="px-3">
                <p-checkbox
                  class="mr-1"
                  formControlName="articolo82"
                  [binary]="true"
                  inputId="articolo82" />
                <label class="checkboxLabelCustom" for="articolo82">
                  {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.statoIscritto.articolo82') }}
                </label>
              </div>
              <div class="px-3">
                <p-checkbox
                  class="mr-1"
                  formControlName="dipendentePubblico"
                  [binary]="true"
                  inputId="dipendentePubblico" />
                <label class="checkboxLabelCustom" for="dipendentePubblico">
                  {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.statoIscritto.dipendentePubblico') }}
                </label>
              </div>
            </div>
            <!-- terza riga -->
            <div class="flex flex-wrap mb-3 gap-4">
              <div class="flex align-items-center pl-3 mb-5">
                <p-checkbox
                  class="mr-1"
                  formControlName="professoreUniversitario"
                  [binary]="true"
                  inputId="professoreUniversitario" />
                <label class="checkboxLabelCustom" for="professoreUniversitario">
                  {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.statoIscritto.professoreFlag') }}
                </label>
              </div>
              <div>
                <span class="p-float-label px-3 mb-6">
                  <p-autoComplete
                    [dropdown]="true"
                    dropdownMode="current"
                    appendTo="body"
                    formControlName="professoreUniversita"
                    [suggestions]="filteredUniversita"
                    (completeMethod)="filterAutoComplete($event, 'universita')"
                    field="nome"
                    [minLength]="3"
                    [showClear]="true">
                    <ng-template let-uni pTemplate="item">
                      <div class="flex align-items-center gap-2">
                        <div>{{ uni.nome }}</div>
                      </div>
                    </ng-template>
                  </p-autoComplete>
                  <label class="pl-1" for="professoreUniversita" [ngClass]="{'custom-tab-panel': iscrittoForm.get('albo.professoreUniversita')?.invalid}">
                    {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.statoIscritto.professoreUniversita') }}
                  </label>
                </span>
              </div>
            </div>
          </p-fieldset>
        </div>
      </p-tabPanel>

      <!-- annotazioni -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <span>{{ translate.instant('gestioneAlbo.dettaglioIscritto.tab.annotazioni') }}</span>
        </ng-template>
        <div class="backPanel border-round-3xl p-5">
          <div class="pl-5">
            <p style="white-space: pre-line">{{ annotazioni }}</p>
          </div>
        </div>
      </p-tabPanel>

      <!-- pagamenti -->
      @if(!nuovoIscritto){
        <p-tabPanel>
          <ng-template pTemplate="header">
            <span>{{ translate.instant('gestioneAlbo.dettaglioIscritto.tab.pagamenti') }}</span>
          </ng-template>
          <div class="backPanel border-round-3xl pagamenti">
            <div class="px-5 pt-3 pb-5">
              <app-tabella-pagamenti [data]="listaData"></app-tabella-pagamenti>
            </div>
          </div>
        </p-tabPanel>
        <!-- modifiche -->
        <p-tabPanel [id]="'modifiche'" #modifiche>
          <ng-template pTemplate="header" >
            <span>{{ translate.instant('gestioneAlbo.dettaglioIscritto.tab.modifiche') }}</span>
          </ng-template>
          <ng-template pTemplate="content">
            <div class="backPanel border-round-3xl py-5 px-6">
              <p-table [value]="audiltLog" dataKey="eventId" [tableStyle]="{ 'min-width': '60rem' }" [expandedRowKeys]="expandedRows">
                <ng-template pTemplate="caption">
                  <div class="flex flex-wrap justify-content-end gap-2">
                    <p-button class="buttonToggle" [label]="translate.instant('gestioneAlbo.dettaglioIscritto.form.modifiche.espandi')" icon="pi pi-plus" text (onClick)="expandAllLog()" />
                    <p-button class="buttonToggle" [label]="translate.instant('gestioneAlbo.dettaglioIscritto.form.modifiche.chiudi')" icon="pi pi-minus" text (onClick)="collapseAllLog()" />
                  </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 5rem"></th>
                    <th pSortableColumn="timestamp">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.modifiche.timestamp') }}
                      <p-sortIcon field="actionDateTime" />
                    </th>
                    <th pSortableColumn="username">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.modifiche.utente') }}
                      <p-sortIcon field="applicationUserName" />
                    </th>
                    <th pSortableColumn="application">
                      {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.modifiche.applicazione') }}
                      <p-sortIcon field="applicationName" />
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-log let-expanded="expanded">
                  <tr>
                    <td>
                      <p-button
                        type="button"
                        pRipple
                        [pRowToggler]="log"
                        [text]="true"
                        [rounded]="true"
                        [plain]="true"
                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
                    </td>
                    <td>{{ log.actionDateTime | date:'dd/MM/yyyy HH:mm:ss' }}</td>
                    <td>{{ log.applicationUserName}}</td>
                    <td>{{ log.applicationName }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="rowexpansion" let-log>
                  <tr>
                    <td colspan="7">
                      <div class="p-3">
                        <p-table [value]="log.changes" dataKey="attribute">
                          <ng-template pTemplate="header">
                            <tr>
                              <th pSortableColumn="attribute">
                                {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.modifiche.attributo') }}
                                <p-sortIcon field="attribute" />
                              </th>
                              <th pSortableColumn="previouse">
                                {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.modifiche.vecchioValore') }}
                                <p-sortIcon field="previousValue" />
                              </th>
                              <th pSortableColumn="new">
                                {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.modifiche.nuovoValore') }}
                                <p-sortIcon field="newValue" />
                              </th>
                              <th style="width: 4rem"></th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-change>
                            <tr>
                              <td>{{ change.attribute }}</td>
                              <td>{{ change.previousValue }}</td>
                              <td>{{ change.newValue }}</td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td colspan="6">
                                {{ translate.instant('gestioneAlbo.dettaglioIscritto.form.modifiche.empty') }}
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </ng-template>
        </p-tabPanel>

        <!-- cronologie -->
         @if(sospensioni.length > 0){
          <p-tabPanel [id]="'cronologie'" #cronologie>
            <ng-template pTemplate="header" >
              <span>{{ translate.instant('gestioneAlbo.dettaglioIscritto.tab.cronologie') }}</span>
            </ng-template>
            <div class="flex flex-column backPanel border-round-3xl px-5 pt-5 pb-2">
              <div class="flex flex-wrap">
                <p-fieldset [legend]="translate.instant('gestioneAlbo.dettaglioIscritto.cronologie.sospensioni.titleFieldset')" class="mb-6 w-full">
                  <p-table [value]="sospensioni" styleClass="pb-4">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>{{ translate.instant('gestioneAlbo.dettaglioIscritto.cronologie.sospensioni.sospesoDal') }}</th>
                        <th>{{ translate.instant('gestioneAlbo.dettaglioIscritto.cronologie.sospensioni.sospesoAl') }}</th>
                        <th>{{ translate.instant('gestioneAlbo.dettaglioIscritto.cronologie.sospensioni.motivoSospensione') }}</th>
                        <th>{{ translate.instant('gestioneAlbo.dettaglioIscritto.cronologie.sospensioni.procedimento') }}</th>
                        <th style="width: 4rem"></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-sos>
                      <tr>
                        <td>{{ sos.sospensioneDal ? (sos.sospensioneDal | date: 'dd/MM/yyyy') : null }}</td>
                        <td>{{ sos.sospensioneAl ? (sos.sospensioneAl | date: 'dd/MM/yyyy') : null }}</td>
                        <td>{{ sos.motivoSospensione ? sos.motivoSospensione.descrizione : null }}</td>
                        <td>{{ getStatoProcedimento(sos.procedimentoDisciplinare) }}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </p-fieldset>
              </div>
            </div>
          </p-tabPanel>
        }
      }
    </p-tabView>
  </form>

  @if(alboRole){
    <div class="flex align-items-center absolute top-0 right-0 mr-6 mt-8 pt-5">
      @if(!nuovoIscritto && infoOriginali?.statoIscritto?.codiceCnop !== 'P'){
        @if(syncSpinner){
          <div class="pr-4 pt-1">
            <i class="pi pi-spin pi-cog" style="font-size: 2rem"></i>
          </div>
        }
        @else{
          <div>
            <p-button
              icon="pi pi-upload"
              (click)="startSynch(infoOriginali?.anagrafica!.id!)"
              class="mr-3"
              [disabled]="disableBottoneSync() || !role_service.isAlboRole()"
              [pTooltip]="translate.instant('tooltip.aggiornaIscritto')"
              tooltipPosition="bottom" />
          </div>
        }
      }
      @if(isLoadingSpinner){
        <div class="pl-2 pr-4 pt-1">
          <i class="pi pi-spin pi-cog" style="font-size: 2rem"></i>
        </div>
      }
      @else{
        <div>
          <p-button
            icon="pi pi-save"
            [disabled]="disableBottoneSalva() || !role_service.isAlboRole()"
            (click)="inviaDatiIscritto()"
            class="mr-3"
            [pTooltip]="translate.instant('tooltip.salva')"
            tooltipPosition="bottom"></p-button>
        </div>
      }
      @if(!nuovoIscritto){
        <div>
          <p-menu #menu [model]="vociStampa" [popup]="true" appendTo="body"></p-menu>
          <!-- label="Stampa" -->
          <button
            pButton
            type="button"
            (click)="menu.toggle($event)"
            icon="pi pi-print"
            [disabled]="!role_service.isAlboOrConsultazione()"
            [pTooltip]="translate.instant('tooltip.stampe')"
            tooltipPosition="bottom"></button>
        </div>
      }
    </div>
  }
</div>